<template>
    <div style="height: 100%">
        <div class="chart" ref="chartdiv"></div>
    </div>
</template>

<script>

    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import themeDark from "@amcharts/amcharts4/themes/dark";

    am4core.useTheme(themeDark);

    export default {

        components: {},

        props: {
            data: {
                type: Array,
                required: true
            },
            title: {
                type: String,
                required: false,
                default: null
            },
        },

        data() {
            return {
                chart: null,
            }
        },

        watch: {
            data() {
                this.prepareChart();
            }
        },

        mounted() {
            this.prepareChart();
        },

        methods: {

            prepareData() {
                this.chart.data = this.data;
            },

            prepareChart() {

                if (this.data.length === 0) return false;

                this.chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart);
                this.chart.innerRadius = am4core.percent(40);
                this.chart.colors.list = [
                    am4core.color("#1976D2"),
                    am4core.color("#FFAB00"),
                    am4core.color("#BF360C"),
                    am4core.color("#388E3C"),
                    am4core.color("#FFC75F"),
                    am4core.color("#F9F871")
                ];

                if (this.title) {
                    let title = this.chart.titles.create();
                    title.text = this.title;
                    title.fontSize = 25;
                    title.marginBottom = 15;
                }

                // Create series
                let series = this.chart.series.push(new am4charts.PieSeries());
                series.dataFields.value = "value";
                series.dataFields.category = "label";
                series.slices.template.stroke = am4core.color("#81abff");
                series.slices.template.strokeWidth = 2;
                series.slices.template.strokeOpacity = 0.5

                this.prepareData();
            }
        }
    }
</script>
